import { BLAdmin } from "./types";

export const parsePath = (path: string, apiHostname: string) => {
	if (!path.startsWith('/')) {
		return path;
	} else {
		return `${apiHostname}${path}`;
	}
};

export const isJsonResponse = (response: Response) => {
	return response.headers.get('Content-Type')?.includes('application/json');
};

export function jwtDecode<T>(token: string): BLAdmin | T {
	const base64Url = token.split('.')[1];
	const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
	const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
		return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
	}).join(''));

	return JSON.parse(jsonPayload);
}

export function isApiUrlSameOrigin(url: string): boolean {
	try {
		const urlObj = new URL(url);
		const [stageSub, stageDomain, stageTld] = urlObj.hostname.split('.');
		const [currentSub, currentDomain, currentTld] = location.hostname.split('.');
		
		if (isLocalhost(url)) {
			return false;
		}

		return `${stageDomain}.${stageTld}` === `${currentDomain}.${currentTld}`;
	} catch {
		return false;
	}
}

export function isLocalhost(url: string): boolean {
	try {
		const urlObj = new URL(url);
		const [stageSub] = urlObj.hostname.split('.');
		const [currentSub] = location.hostname.split('.');
		
		return stageSub === 'localhost' || currentSub === 'localhost';
	} catch {
		return false;
	}
}

// Make sure to add all new functions to __mocks__/utils.ts to fix testing in other files
